export const TRANSACTION_FEE = 2.0;

export const DISCOUNT_MAPPING = [
  { key: 'multiple_pet_discount_percentage', label: 'Multi-pet discount' },
  { key: 'group_discount_percentage', label: 'Priority Code' },
  { key: 'healthy_pet_discount_percentage', label: 'Healthy Pet Discount' },
];
